// Prevent duplicate script loading
if (window.LimitedProductsInitialized) {
  console.debug('[limited-products.js] Script already initialized, skipping...');
} else {
  window.LimitedProductsInitialized = true;

const ACTIVE_CLASS = 'is-active';
const LOCKED_CLASS = 'is-locked';
const bodyOverlay = document.querySelector('.body-overlay');

let startDate, endDate;
let dateButtonsProcessed = new Set();

function displayPopup() {
  const dateRange = document.querySelector('.product-date-range');
  if (!dateRange) return;

  limitedReleasePopup?.classList.add(ACTIVE_CLASS);

  const title = limitedReleasePopup?.querySelector('p');
  const imageElement = limitedReleasePopup?.querySelector('img');
  
  if (title) title.textContent = dateRange.dataset.title;
  if (imageElement) imageElement.src = dateRange.dataset.image;

  bodyOverlay?.classList.add(ACTIVE_CLASS);
  document.body.classList.add(LOCKED_CLASS);
}

function removeLineItem() {
  const productDateRangeEl = document.querySelector('.product-date-range');
  if (!productDateRangeEl) return;

  fetch(productDateRangeEl.dataset.productUrlToRemove, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    },
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const contentType = response.headers.get('content-type');
      return contentType?.includes('application/json')
        ? response.json()
        : response.text().then(() => ({ status: 'success', message: 'Item removed' }));
    })
    .catch(error => console.error('[removeLineItem] Error:', error));
}

function hidePopup() {
  limitedReleasePopup?.classList.remove(ACTIVE_CLASS);
  bodyOverlay?.classList.remove(ACTIVE_CLASS);
  document.body.classList.remove(LOCKED_CLASS);
}

function parseDateString(dateStr) {
  if (!dateStr) return null;
  
  // Handle "2025/08/28" format (Zapiet ISO format)
  if (dateStr.match(/^\d{4}\/\d{2}\/\d{2}$/)) {
    return dateStr.replace(/\//g, '-');
  }
  
  // Handle "Wed, 27 August, 2025" format
  if (dateStr.match(/^[A-Za-z]{3},\s+\d{1,2}\s+[A-Za-z]+,\s+\d{4}$/)) {
    const [, dayMonth, year] = dateStr.split(', ');
    const [day, month] = dayMonth.split(' ');
    
    const monthNames = {
      'January': '01', 'February': '02', 'March': '03', 'April': '04',
      'May': '05', 'June': '06', 'July': '07', 'August': '08',
      'September': '09', 'October': '10', 'November': '11', 'December': '12'
    };
    
    const monthNum = monthNames[month];
    if (monthNum) {
      return `${year}-${monthNum}-${day.padStart(2, '0')}`;
    }
  }
  
  // Try direct parsing
  const date = new Date(dateStr);
  return !isNaN(date.getTime()) ? date.toISOString().split('T')[0] : null;
}

function isDateInRange(pickedDateStr, startDateStr, endDateStr) {
  if (!pickedDateStr || !startDateStr || !endDateStr) return false;

  const parsedPickedDate = parseDateString(pickedDateStr);
  if (!parsedPickedDate) return false;

  const parseDate = (dateStr) => {
    let date = new Date(dateStr);
    if (isNaN(date.getTime()) && dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
      date = new Date(dateStr + 'T00:00:00');
    }
    return date;
  };

  const currentDate = parseDate(parsedPickedDate);
  const startDate = parseDate(startDateStr);
  const endDate = parseDate(endDateStr);

  if (isNaN(currentDate.getTime()) || isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
    return false;
  }

  // Set times to 00:00:00 for date-only comparison
  [currentDate, startDate, endDate].forEach(date => date.setHours(0, 0, 0, 0));

  return currentDate >= startDate && currentDate <= endDate;
}

function getPickedDate() {
  const selectors = [
    '#Zapiet-InputCalendar__deliveryDate_ISO',
    '[name="datetime"]',
    '#deliveryGeoSearchField', 
    'input[type="date"]',
    '.date-picker-input',
    '#storePickupApp input[type="date"]',
    '#storePickupApp input[name*="date"]',
    '#storePickupApp input[name*="time"]',
    '#storePickupApp .zapiet-date-input',
    '#storePickupApp .zapiet-time-input'
  ];

  // Try Zapiet API first
  if (window.Zapiet?.getSelectedDate) {
    try {
      const zapietDate = window.Zapiet.getSelectedDate();
      if (zapietDate) return zapietDate;
    } catch (e) {
      console.warn('[getPickedDate] Zapiet API error:', e.message);
      // Continue to other methods
    }
  }

  // Try selectors
  for (const selector of selectors) {
    const element = document.querySelector(selector);
    if (element?.value) return element.value;
  }

  // Look for any date-related inputs
  const dateInputs = document.querySelectorAll('#storePickupApp input');
  for (const input of dateInputs) {
    if (input.name?.match(/(date|time|datetime)/) && input.value) {
      return input.value;
    }
  }

  return null;
}

function isValidDateString(dateStr) {
  if (typeof dateStr !== 'string') return false;
  
  // Check for location strings
  const locationKeywords = ['Australia', 'NSW', 'North Steyne', 'Manly'];
  if (locationKeywords.some(keyword => dateStr.includes(keyword))) return false;
  
  // If contains comma, check if it's a date format
  if (dateStr.includes(',')) {
    return dateStr.match(/^[A-Za-z]{3},\s+\d{1,2}\s+[A-Za-z]+,\s+\d{4}$/);
  }
  
  return true;
}

function handleDateSelection() {
  // Use requestAnimationFrame to ensure DOM updates have completed
  requestAnimationFrame(() => {
    const pickedDate = getPickedDate();
    
    if (!pickedDate || !isValidDateString(pickedDate)) return;
    
    if (!isDateInRange(pickedDate, startDate, endDate)) {
      removeLineItem();
      displayPopup();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const dateRangeHolder = document.querySelector('.product-date-range');
  startDate = dateRangeHolder?.dataset.startDate;
  endDate = dateRangeHolder?.dataset.endDate;

  if (!dateRangeHolder || !startDate || !endDate) return;

  // Setup popup close listeners
  document.querySelector('.body-overlay')?.addEventListener('click', hidePopup);
  document.querySelector('#closePopupButton')?.addEventListener('click', hidePopup);

  waitForZapiet();
});

function waitForZapiet() {
  let attempts = 0;
  const maxAttempts = 8; // Fewer attempts with longer intervals
  
  const checkZapiet = () => {
    if (window.ZapietEvent) {
      setupZapietListeners();
    } else if (++attempts < maxAttempts) {
      setTimeout(checkZapiet, Math.pow(2, attempts) * 50); // Exponential backoff
    } else {
      setupMutationObserver();
    }
  };
  
  checkZapiet();
}

function setupZapietListeners() {
  const events = ['dateSelected', 'checkoutEnabled', 'dateTimeChanged'];
  events.forEach(event => {
    window.ZapietEvent.listen(event, handleDateSelection);
  });

  // Efficient fallback using MutationObserver instead of polling
  setupDateInputObserver();
}

function createDateInputObserver(observerState) {
  return new MutationObserver(() => {
    const newDate = getPickedDate();
    if (newDate && newDate !== observerState.lastCheckedDate) {
      observerState.lastCheckedDate = newDate;
      handleDateSelection();
    }
  });
}

function setupDateInputObserver() {
  const observerState = { lastCheckedDate: null };
  const observer = createDateInputObserver(observerState);
  
  const observerConfig = { 
    attributes: true, 
    attributeFilter: ['value'] 
  };

  // Primary input
  const isoDateInput = document.querySelector('#Zapiet-InputCalendar__deliveryDate_ISO');
  if (isoDateInput) {
    observer.observe(isoDateInput, observerConfig);
  }

  // Fallback inputs
  const fallbackSelectors = [
    '[name="datetime"]',
    '#deliveryGeoSearchField',
    'input[type="date"]',
    '#storePickupApp input[type="date"]',
    '#storePickupApp input[name*="date"]'
  ];
  
  fallbackSelectors.forEach(selector => {
    const element = document.querySelector(selector);
    if (element) {
      observer.observe(element, observerConfig);
    }
  });
}

function setupMutationObserver() {
  document.querySelectorAll('.hidden-for-terms').forEach((container) => {
    const observer = new MutationObserver(() => {
      document.querySelectorAll('.picker__day:not(.picker__day--disabled)').forEach((dateButton) => {
        if (!dateButtonsProcessed.has(dateButton)) {
          dateButtonsProcessed.add(dateButton);
          dateButton.addEventListener('click', handleDateSelection);
        }
      });
    });

    observer.observe(container, { attributes: true, childList: true, subtree: true });
  });
}

// Expose functions for debugging (only in development)
if (typeof window !== 'undefined') {
  window.LimitedProducts = {
    testDateValidation: (testPickedDate, testStartDate, testEndDate) => 
      isDateInRange(testPickedDate, testStartDate, testEndDate),
    isDateInRange,
    parseDateString
  };
}

} // Close the if statement that prevents duplicate script loading
